// import { useSettings } from "@/store/settingStore";
// import { themeVars } from "@/theme/theme.css";
// import { cn } from "@/utils";
// import { Content } from "antd/es/layout/layout";
// import type { CSSProperties } from "react";
// import { Outlet, useLocation } from "react-router";
// import { ThemeLayout } from "#/enum";
// import { MULTI_TABS_HEIGHT } from "./config";
// import MultiTabs from "./multi-tabs";
// import { MultiTabsProvider } from "./multi-tabs/providers/multi-tabs-provider";

// const Main = () => {
//     const { themeStretch, themeLayout, multiTab } = useSettings();
//     const location = useLocation();

//     const isNoScrollPage = location.pathname === "/dashboard/dashboard-playgrounds";

//     const mainStyle: CSSProperties = {
//         paddingTop: multiTab ? MULTI_TABS_HEIGHT : 0,
//         background: themeVars.colors.background.default,
//         transition: "all 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
//         width: "100%",
//         boxSizing: "border-box",
//     };

//     return (
//         <Content style={mainStyle} className="flex w-full max-w-full">
//             <div className={cn(
//                 "flex-grow size-full",
//                 isNoScrollPage ? "overflow-hidden" : "overflow-auto"
//             )}
//             >
//                 <div
//                     className={cn(
//                         "size-full flex-grow mx-3 ",
//                         themeStretch ? "" : "xl:w-[98%]",
//                         themeLayout === ThemeLayout.Horizontal ? "flex-col" : "flex-row",
//                     )}
//                 >
//                     {multiTab ? (
//                         <MultiTabsProvider>
//                             <MultiTabs />
//                         </MultiTabsProvider>
//                     ) : (
//                         <Outlet />
//                     )}
//                 </div>
//             </div>
//         </Content>
//     );
// };

// export default Main;

// import { useSettings } from "@/store/settingStore";
// import { themeVars } from "@/theme/theme.css";
// import { cn } from "@/utils";
// import { Content } from "antd/es/layout/layout";
// import type { CSSProperties } from "react";
// import { Outlet, useLocation } from "react-router";
// import { ThemeLayout } from "#/enum";
// import { MULTI_TABS_HEIGHT } from "./config";
// import MultiTabs from "./multi-tabs";
// import { MultiTabsProvider } from "./multi-tabs/providers/multi-tabs-provider";

// const Main = () => {
//     const { themeStretch, themeLayout, multiTab } = useSettings();
//     const location = useLocation();

//     const isNoScrollPage =
//         location.pathname === "/dashboard/dashboard-playgrounds" ||
//         location.pathname === "/dashboard/smart-dashboard-agent";

//     const mainStyle: CSSProperties = {
//         paddingTop: multiTab ? MULTI_TABS_HEIGHT : 0,
//         background: themeVars.colors.background.default,
//         transition: "all 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
//         width: "100%",
//         boxSizing: "border-box",
//     };

//     return (
//         <Content style={mainStyle} className="flex w-full max-w-full">
//             <div className={cn(
//                 "flex-grow size-full",
//                 isNoScrollPage ? "overflow-hidden" : "overflow-auto"
//             )}
//             >
//                 <div
//                     className={cn(
//                         "size-full flex-grow mx-3 ",
//                         themeStretch ? "" : "xl:w-[98%]",
//                         themeLayout === ThemeLayout.Horizontal ? "flex-col" : "flex-row",
//                     )}
//                 >
//                     {multiTab ? (
//                         <MultiTabsProvider>
//                             <MultiTabs />
//                         </MultiTabsProvider>
//                     ) : (
//                         <Outlet />
//                     )}
//                 </div>
//             </div>
//         </Content>
//     );
// };

// export default Main;

// import { useSettings } from "@/store/settingStore";
// import { themeVars } from "@/theme/theme.css";
// import { cn } from "@/utils";
// import { Content } from "antd/es/layout/layout";
// import type { CSSProperties } from "react";
// import { Outlet, useLocation } from "react-router";
// import { ThemeLayout } from "#/enum";
// import { MULTI_TABS_HEIGHT } from "./config";
// import MultiTabs from "./multi-tabs";
// import { MultiTabsProvider } from "./multi-tabs/providers/multi-tabs-provider";

// const Main = () => {
//     const { themeStretch, themeLayout, multiTab } = useSettings();
//     const location = useLocation();

//     const isNoScrollPage = location.pathname === "/dashboard/dashboard-playgrounds";

//     const mainStyle: CSSProperties = {
//         paddingTop: multiTab ? MULTI_TABS_HEIGHT : 0,
//         background: themeVars.colors.background.default,
//         transition: "all 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
//         width: "100%",
//         boxSizing: "border-box",
//     };

//     return (
//         <Content style={mainStyle} className="flex w-full max-w-full">
//             <div className={cn(
//                 "flex-grow size-full",
//                 isNoScrollPage ? "overflow-hidden" : "overflow-auto"
//             )}
//             >
//                 <div
//                     className={cn(
//                         "size-full flex-grow mx-3 ",
//                         themeStretch ? "" : "xl:w-[98%]",
//                         themeLayout === ThemeLayout.Horizontal ? "flex-col" : "flex-row",
//                     )}
//                 >
//                     {multiTab ? (
//                         <MultiTabsProvider>
//                             <MultiTabs />
//                         </MultiTabsProvider>
//                     ) : (
//                         <Outlet />
//                     )}
//                 </div>
//             </div>
//         </Content>
//     );
// };

// export default Main;

import { useSettings } from "@/store/settingStore";
import { themeVars } from "@/theme/theme.css";
import { cn } from "@/utils";
import { Content } from "antd/es/layout/layout";
import { type CSSProperties } from "react";
import { Outlet, useLocation } from "react-router";
import { ThemeLayout } from "#/enum";
import { MULTI_TABS_HEIGHT } from "./config";
import MultiTabs from "./multi-tabs";
import { MultiTabsProvider } from "./multi-tabs/providers/multi-tabs-provider";
const Main = () => {
  const {
    themeStretch,
    themeLayout,
    multiTab
  } = useSettings();
  const location = useLocation();
  const isNoScrollPage = location.pathname === "/dashboard/dashboard-playgrounds" || location.pathname === "/dashboard/smart-dashboard-agent";
  // location.pathname === "/dashboard/instant-ai-dashboard" || location.pathname === "/agents/dashboard-clean-workflow-agent";

  const mainStyle: CSSProperties = {
    paddingTop: multiTab ? MULTI_TABS_HEIGHT : 0,
    background: themeVars.colors.background.default,
    transition: "all 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    width: "100%",
    boxSizing: "border-box"
  };

  // const [remainModalOpen ,   setRemainModal] = useState(false)

  return <Content style={mainStyle} className="flex w-full max-w-full">
            <div className={cn("flex-grow size-full", isNoScrollPage ? "overflow-hidden" : "overflow-auto")}>
                <div className={cn("size-full flex-grow mx-3 ", themeStretch ? "" : "xl:w-[98%]", themeLayout === ThemeLayout.Horizontal ? "flex-col" : "flex-row")}>
                    {multiTab ? <MultiTabsProvider>
                            <MultiTabs />
                        </MultiTabsProvider> : <Outlet />}
                </div>
            </div>
        </Content>;
};
export default Main;